module.exports = __webpack_public_path__ + "img/approve.4a1d799e.svg";